import { render, staticRenderFns } from "./POIJobPostings.vue?vue&type=template&id=96dcb252"
import script from "./POIJobPostings.js?vue&type=script&lang=js&external"
export * from "./POIJobPostings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports